









































































































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import PositionDto from '@/models/Positions/PositionDto';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';

@Component({
    name: 'BookingDetailsBookingRoleEdit'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    public index: number;

    public dialog = false;
    public entity = new BookingRoleDto();
    public contactLocation = new ContactLocationDto();
 

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            await BookingDetailsModule.getNewBookingOptions();
            this.entity = JSON.parse(JSON.stringify(BookingDetailsModule.currentBooking.roles[this.index]));
            //Loop through the contact locations and add it in the current component state for selection
            this.contactLocation = this.contactLocations.find((findContactLocation: ContactLocationDto) => findContactLocation.contactId === this.entity.contactId);
            //console.log (this.contactLocation);
        }
    }

    get skills() {
        if (this.entity.id == null) {
            return [];
        }
        const index = BookingDetailsModule.currentBooking.location.rateCard.positions.findIndex((findPosition: RateCardPositionDto) => this.entity.positionId === findPosition.positionId);
        return BookingDetailsModule.currentBooking.location.rateCard.positions[index].position.skills;
    }

     get qualifications() {
        if (this.entity.id == null) {
            return [];
        }
        const index = BookingDetailsModule.currentBooking.location.rateCard.positions.findIndex((findPosition: RateCardPositionDto) => this.entity.positionId === findPosition.positionId);
        return BookingDetailsModule.currentBooking.location.rateCard.positions[index].position.qualifications;
    }

    get agencyUsers() {
      return BookingDetailsModule.newBookingOptions.agencyUsers;
    }


    get desks() {
        return BookingDetailsModule.currentBooking.branch.desks;
    }

    get uniforms() {
        if (this.entity.id == null) {
            return [];
        }
        const index = BookingDetailsModule.currentBooking.location.rateCard.positions.findIndex((findPosition: RateCardPositionDto) => this.entity.positionId === findPosition.positionId);
        return BookingDetailsModule.currentBooking.location.rateCard.positions[index].position.uniforms;
    }

    get selectedUniform() {
        return this.entity.uniform;
    }

    set selectedUniform(value) {
        this.entity.uniform = value;
        this.entity.uniformId = value.id;
        this.entity.uniformDescription = value.description;
    }

    get currentPosition() {
        return this.entity.position;
    }

    get contactLocations() {
        return BookingDetailsModule.currentBooking.location.contactLocations;
    }

    get loading() {
        return BookingDetailsModule.loadingDialog;
    }

    save() {
        if (!(this.$refs.form as any).validate()) {
        return;
        }
        this.entity.contactId = this.contactLocation.contactId;
        this.entity.ownerId = this.entity.owner.id;
        BookingDetailsModule.updateBookingRole(this.entity);
        this.dialog = false;
    }
}
